<template>
	<v-container fluid full-width style="padding: 0px;height:100%;width:100%">
	  <v-layout row wrap>
		<v-flex id = "videocontain" xs12 sm12 md12 lg12 xl12 >
		  <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" style="position: relative; width:100% ;height:100vh;overflow: hidden;"> 
									
			<video id='videocase' ref="video" autoplay playsinline webkit-playsinline style="padding: 0px;position:absolute;width:100%;height:100%;object-fit: cover;border:none"></video>
			<!-- <canvas ref="canvas"></canvas> -->
			<canvas ref="canvasoverlay" width=100% height="100%" style="display:none ;position: absolute; background: transparent; top: 0%; right: 0; left: 0; left: 0%;pointer-events: none"></canvas>
			<div class="text-container" width=100% height="auto" >
			<!-- <div id="estimated_age" style="font-size: 14px;">Estimated age: - </div>
			<div id="lighting" style="font-size: 10px;">Lighting: - </div>
			<div id="blur" style="font-size: 10px;">Blur: -</div>
			<div id="head_tilt" style="font-size: 10px;">Head_tilt: -</div>
			<div id="head_left_right" style="font-size: 10px;">Head_left_right: -</div>
			<div id="head_up_down" style="font-size: 10px;">Head_up_down: -</div> -->
			<!-- <div id='timer'>Timer: {{ timerCount }} Sec</div> -->
			<div id="instruction-text" style="display: none;">
			  
			</div>
			</div>
			
			
											
									  
		  </div>
		  
		</v-flex>
		<div id="result" style="display: none;height:100%;width:100%">
			
		  
		</div>
	  </v-layout>
	  </v-container>
	  
	  
  </template>
	
	<script>
	import axios from "axios";
	
	axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
	axios.defaults.withCredentials = false;
	
	
	export default {
	  name: "ConitnuousAge",
	  data() {
		return {
			loading: false,
			predictioncl: "",
			// api_url:"http://127.0.0.1:8082/",
			isCameraOpen: false,
			isLoading: false,
			socket :null,
			video : null,
			ctx_overlay: null,
			lines: [],
			timerCount:'-',
			timelimit:15,
			terminated:0,
			imageData:'',
		};
	  },
	  watch:{
		timerCount(val){
		  if (this.terminated == 1){
			console.log("Session terminated!")
			window.close();
		  }
		  else if(val<=this.timelimit && val>=0 ){
			setTimeout(this.timerstart,1000);
		  }
		  else if(val<0 && this.terminated == 0){
			document.getElementById("videocontain").style.display = 'none';
			document.getElementById("result").style.display ='none';
			document.getElementById("result").style.color ='red';
			document.getElementById("result").innerText ='Timed Out !';
			this.terminated = 1;
			var information = {
					timer: this.timerCount,
					estimated_age:  "Timed Out!",
					image: this.imageData,
				};
			this.sendtoparent(information);
			this.stopCamera();
			this.socketdisconnect();
		  }
  
  
		}
  
	  },
	  mounted() {
	  this.handleWindowResize(); // Call the function on initial mount
	  // Add event listener for window resize
	  window.addEventListener('resize', this.handleWindowResize);
	  this.toggleCamera();
	  
	  },
	  beforeMount() {
		this.socketconnect();
	  },
	  beforeDestroy() {
		// Remove event listener when the component is destroyed
		window.removeEventListener('resize', this.handleWindowResize);
		this.socketdisconnect();
	  },
	  methods: {
		timerstart(){
		this.timerCount--;
		},
		handleWindowResize() {
			const windowWidth = window.innerWidth;
			const windowHeight = window.innerHeight;
  
		  // Determine the shortest length (width or height)
		  // const shortestLength = Math.max(windowWidth, windowHeight);
  
		  // // Update the CSS property dynamically
		  // this.containerStyle = {
		  // width: `${shortestLength}px`,
		  // height: `${shortestLength}px`,
		  // };
		},
		socketconnect() {
			this.$socket = io('https://fallback-server-for-on-browser.privately.swiss:8997')
			// $socket is socket.io-client instance
			this.$socket.on("connect", () => {
				console.log('Connection established.');
				console.log('ID:', this.$socket.id);
				// captureVideo();
			});
		}, 
		socketdisconnect() {
			this.$socket.disconnect();
			// $socket is socket.io-client instance
			this.$socket.on("disconnect", () => {
			console.log('Session disconnected.');
			// captureVideo();
			});
		}, 
		clickButton(data) {
			  // $socket is socket.io-client instance
			this.$socket.emit('emit_method', data)
		},
		sendtoparent(information){
			parent.postMessage(information,"*")
		},
		toggleCamera() {
		  // if(this.isCameraOpen) {
		  //   this.isCameraOpen = false;
		  //   this.socketdisconnect();
		  //   this.stopCamera();
		  //   document.getElementById("videocontain").style.textAlign = 'center'
		  //   document.getElementById("stopbutton").style.display = 'none';
		  //   document.getElementById("startbutton").style.display = 'inline-block';
	
		  // } else {
			this.isCameraOpen = true;
			this.startCamera();
			document.getElementById("videocontain").style.textAlign = 'left'
			// document.getElementById("stopbutton").style.display = 'inline-block';
			// document.getElementById("startbutton").style.display = 'none';
			
		  // }
		},
		updateResponse(data){
			var response = 'No Face detected';
			document.getElementById("instruction-text").style.color = '#007BFF';
  
			if (data['estimated_age']=='-'|| data['estimated_age']=='No Face'){

				document.getElementById("instruction-text").innerHTML = 'No face detected!';
				response = 'No Face detected!';
  
			} else if ( data['estimated_age']=="Multiple Faces"){ 
  
				document.getElementById("instruction-text").innerHTML = 'Multiple faces detected!';
				response = 'Multiple faces detected!';
  
			} else if ( data['estimated_age']=="Bad Env/Pose"){
  
				if(data['lighting'][0]!='good'){
					document.getElementById("instruction-text").innerHTML = 'Please be in a well lit environment';
					response = 'Please be in a well lit environment';
				} else if (data['head_up_down'][0]!='straight'|| data['head_tilt'][0]!='straight' || data['head_left_right'][0]!='straight'){
					document.getElementById("instruction-text").innerHTML = 'Keep your face straight and aligned!'
					response = 'Keep your face straight and aligned!';
				} else if(data['blur'][0]!='clear'){
					document.getElementById("instruction-text").innerHTML = 'Video is blur'
					response = 'Video is blur!';
				}

		 	} else if (data['estimated_age']=='collecting_images'){
				document.getElementById("instruction-text").style.color = '#39FF14';
				document.getElementById("instruction-text").innerHTML = 'Looking good! Stay Still...'
				response = 'Looking good! Stay Still...';
		  	} else if ( data['estimated_age']=='True' || data['estimated_age']=='False'){
				document.getElementById("videocontain").style.display = 'none';
				document.getElementById("result").style.display ='none';
				if (data['estimated_age']=='True'){
					document.getElementById("result").style.color ="green";
					document.getElementById("result").innerText ="Result: User is >= 21 years old";
				}else{
					document.getElementById("result").style.color ="red";
					document.getElementById("result").innerText ="Result: User is < 21 years old";
				}
				this.terminated = 1;

				response = data['estimated_age'];
				this.stopCamera();
				this.socketdisconnect();
			  
		}
		var information = {
					timer: this.timerCount,
					estimated_age:  response,
					image: this.imageData,
				};
		// console.log(information)
		this.sendtoparent(information);
  
		  
  
		  // if ( data['estimated_age']=="Bad Env/Pose" || data['estimated_age']=='-'|| data['estimated_age']=='No Face') {
		  //     document.getElementById("estimated_age").style.color = 'red';
		  // } else {
		  //     document.getElementById("estimated_age").style.color = 'green';
		  // }
		  // if ( data['estimated_age']=='-' || data['estimated_age']=='No Face'){
		  //     data['estimated_age'] = 'No face detected'
		  // }
		  // document.getElementById('estimated_age').innerText = "Estimated age >21: " + data['estimated_age'];
		  // if ( data['estimated_age']=='True' || data['estimated_age']=='False'){
		  //     document.getElementById("videocontain").style.display = 'none';
		  //     document.getElementById("result").style.display ='block';
		  //     document.getElementById("result").innerText ="Estimated age >21: " + data['estimated_age'];
		  //     this.stopCamera()
		  //     this.socketdisconnect()
		  // }
		  // if ( data['lighting'][0]=='good') {
		  //     document.getElementById("lighting").style.color = 'green';
		  // } else {
		  //     document.getElementById("lighting").style.color = 'red';
		  // }
		  // document.getElementById("lighting").innerText = "Lighting: " + data['lighting'][0];
  
		  // document.getElementById("blur").innerText = "Blur: " + data['blur'][0];
  
		  // if ( data['blur'][0]=='clear') {
		  //     document.getElementById("blur").style.color = 'green';
		  // } else {
		  //     document.getElementById("blur").style.color = 'red';
		  // }
  
		  // if ( data['head_tilt'][0]=='straight') {
		  //     document.getElementById("head_tilt").style.color = 'green';
		  // } else {
		  //     document.getElementById("head_tilt").style.color = 'red';
		  // }
		  // document.getElementById("head_tilt").innerText = "Head_tilt: "+data['head_tilt'][0] 
  
		  // if ( data['head_left_right'][0]=='straight') {
		  //     document.getElementById("head_left_right").style.color = 'green';
		  // } else {
		  //     document.getElementById("head_left_right").style.color = 'red';
		  // }
		  // document.getElementById("head_left_right").innerText = "Head_left_right: " + data['head_left_right'][0] 
  
		  // if ( data['head_up_down'][0]=='straight') {
		  //     document.getElementById("head_up_down").style.color = 'green';
		  // } else {
		  //     document.getElementById("head_up_down").style.color = 'red';
		  // }
		  // document.getElementById("head_up_down").innerText = "Head_up_down: " + data['head_up_down'][0];
	
		},
		startCamera() {
		// this.socketconnect();
		if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
		  navigator.mediaDevices
			.getUserMedia({ video: true })
			.then((stream) => {
			  this.videoStream = stream;
			  this.$refs.video.srcObject = stream;
			  this.startFrameRelay();
			})
			.catch((error) => {
			  console.error('Error accessing camera:', error);
			});
		} else {
		  console.error('getUserMedia is not supported');
		}
	  },
	  stopCamera() {
		// this.socketdisconnect();
		if (this.videoStream) {
		  this.videoStream.getTracks().forEach((track) => {
			track.stop();
		  });
		  this.$refs.video.srcObject = null;
		  this.stopFrameRelay();
		}
	  },
  
		startFrameRelay() {
		// Get the canvas element
		const canvas = this.$refs.canvasoverlay;
		const video = this.$refs.video;
		const context = canvas.getContext('2d');
		this.timerCount = this.timelimit;
		
		// Create a new image every 100ms and send it to the server
		this.intervalId = setInterval(() => {
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;
			// console.log("Size"+ canvas.width+"," +canvas.height)
			context.drawImage(this.$refs.video, 0, 0, canvas.width, canvas.height);
			this.imageData = canvas.toDataURL('image/jpeg');
			// Send the image data to the server via Socket.IO
			this.$socket.emit('image',{'image': this.imageData});
			// requestAnimationFrame(sendFrame);
			this.$socket.on('image_resp', (data) => {
			// console.log("Estimated Age: "+ data['estimated_age']);
			this.updateResponse(data)
			// sending data to parent iframe
		  
		});
  
		},200);
  
		
	  
	  },
	  stopFrameRelay() {
		// Disconnect from the Socket.IO server
		if (this.$socket) {
		  this.$socket.disconnect();
		}
		clearInterval(this.intervalId);
	  },
  
		resetpredictionlabel() {
		  this.predictionResult = "--";
		  this.predictionScore = " ";
		  document.getElementById("prediction").style.color = "#000000";
		},
  
	  },
	};
	</script>
	<style>
	  .analysis{
		z-index: 2;
	  
	  }
	  .button{
		border: 1px solid #fff;
	  color: #fff;
	  padding: 10px;
	  border-radius: 8px;
	  display: inline-block;
	  text-align: center;
	  margin: 10px 10px 10px 10px;
	  text-decoration:none;
	  text-align: center;
	  width:250px;
	  height: 50px;
	  font-weight: bold;
	}
	#stopbutton{
		border: 1px solid #fff;
	  color: #fff;
	  padding: 10px;
	  border-radius: 8px;
	  display: none;
	  text-align: center;
	  margin: 10px 10px 10px 10px;
	  text-decoration:none;
	  text-align: center;
	  width:250px;
	  height: 50px;
	  font-weight: bold;
	  /* display: none; */
	}
	.text-container{
	  position: absolute; 
	  background: transparent; 
	  top: 0%; 
	  right: 0%; 
	  left: 0%; 
	  pointer-events: none;
	  /* background:rgba(255, 255, 255, 0.25); */
	  /* text-shadow: -1px -1px 0 #493a3a, 1px -1px 0 #493a3a, -1px 1px 0 #493a3a, 1px 1px 0 #493a3a; */
	  letter-spacing: 1px;
	  -webkit-text-stroke: 0.5px #493a3a;
	}
	#videocase{
	  transform: rotateY(180deg);
	  -webkit-transform:rotateY(180deg); /* Safari and Chrome */
	  -moz-transform:rotateY(180deg); /* Firefox */
	}
	#instruction-text{
	  font-size: 220%; /* Responsive font size */
	  margin-top: 0%;
	  text-align: center;
	  /* background-color: grey; */
	  z-index: 2; /* Dark grey text */
	  color: #007BFF; /* Accent color for highlighting */
	  font-weight: bold;
	  font-family: "Fantasy","sans-serif";
	}
	#timer{
	  color: #007BFF;
	  font-size: 200%;
	  text-align: center;
	  font-weight: bold;
	  font-family: "Fantasy","sans-serif";
  
	}
	#result{
	  text-align: center;
	  padding: 20px;
	  /* margin-top: 25%; */
	  font-size: 130%;
	  color: darkgreen;
	  background-color: white;
	  border-radius: 10px;
	  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	  font-weight: bold;
	  font-family: "Fantasy","sans-serif";
	  vertical-align: middle;
	  align-items: center;
	  margin-top: 25%;
	}
	</style>